/* import __COLOCATED_TEMPLATE__ from './name.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();